import request from '@/utils/request'
import qs from 'qs'
export function cloundList(query) {
  return request({
    url: '/myclouddoc/list.json',
    method: 'get',
    params: query
  })
}

export function searchCloundList(query) {
  return request({
    url: '/MyCloudDoc/cloudname/',
    method: 'get',
    params: query
  })
}
export function deleteClound(query) {
  return request({
    url:"/myclouddoc/delete.json",
    method: 'delete',
    params: query
  })
}
export function updateClound(id,params) {
  return request({
    url:"/myclouddoc/update.json",
    method: 'put',
    params:params
  })
}
export function DlabelTemplate(query) {
  return request({
    url:"/templatesystem/list.json",
    method: 'get',
    params: query
  })
}
export function DlabelTemplateSelect(query) {
  return request({
    url:"/templatesystem/select.json",
    method: 'get',
    params: query
  })
}
export function TemplateCategory(query) {
  return request({
    url:"/templatetype/list.json",
    method: 'get',
    params: query
  })
}

export function getFileSize(query) {
  return request({
    url:"/templatesize/list.json",
    method: 'get',
    params: query
  })
}


//行业分类信息
export function productPrintIndustry(query) {
  return request({
    url:"/productPrint/industry.json",
    method: 'post',
    data:qs.stringify(query)
  })
}
//行业信息
export function productPrintTemplate(query) {
  return request({
    url:"/productPrint/template.json",
    method: 'post',
    data:qs.stringify(query)
  })
}

